import React from "react";

import { HtmlFragment } from "@churchofjesuschrist/eden-html-fragment";
import { spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { Text3 } from "@churchofjesuschrist/eden-text";
import styled from "styled-components";

const Container = styled.div`
  div {
    margin-bottom: ${spacing16} !important;
  }
`;

const mapping = {
  p: Text3,
};
const StyledHtmlFragment = (props = {}) => {
  const {content = ""} = props ?? {};
  return (
    <Container>
      <HtmlFragment {...props} content={content} mappings={mapping} />
    </Container>
  )};

export default StyledHtmlFragment;
